import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/services/util/utility.service';
import { EventsService } from 'src/app/services/events.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SportsService } from 'src/app/services/sports.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { BettingBase } from '../betting-base/betting-base.component';
import { EventMappingType, PageType, SiteViewConfiguration, TimeFilter } from 'src/app/models/enums';
import { UserActivityService } from 'src/app/services/userActivity.service';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { CacheChangesService } from 'src/app/services/cacheChanges.service';
import { UserService } from 'src/app/services/user.service';
import { TicketManagerUserService } from 'src/app/ticket-manager/services/ticketManagerUser.service';
import { DeployParams } from 'src/app/deployParams';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';

@Component({
  selector: 'app-betting-prematch',
  templateUrl: './betting-prematch.component.html',
  styleUrls: ['../betting-base/betting-base.less']
})
export class BettingPrematchComponent extends BettingBase implements OnInit, OnDestroy {
  public srcSelection: ISportRegionCompetitionSelection;
  public eventsMappingTypeEnum = EventMappingType;
  public hideMobileTree = false;
  public viewConfigurations = ViewConfigurations;
  public isResults = false;
  public showResultsTimeFilter = false;
  public resultTimeFilterValue: TimeFilter = TimeFilter.None;

  public resultsToday: Date;
  public resultsD1: Date;
  public resultsD2: Date;
  public resultsD3: Date;
  public resultsD4: Date;
  public resultsD5: Date;
  public resultsD6: Date;

  siteViewConfigurationEnum = SiteViewConfiguration;
  deployParams = DeployParams;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public utilityService: UtilityService,
    public eventsService: EventsService,
    public notificationService: NotificationService,
    public sportsService: SportsService,
    public loaderService: LoaderService,
    public queryParamService: QueryParamsService,
    public userService: UserService,
    public ticketManagerUserService: TicketManagerUserService,
    private userActivityService: UserActivityService,
    private cacheChangesService: CacheChangesService,
    private tmUserService: TicketManagerUserService,
    protected authentificationService: AuthenticationService
  ) {
    super(route, utilityService, eventsService, notificationService, sportsService, loaderService, queryParamService, userService, ticketManagerUserService, authentificationService);
    if (this.isMobileView) {
      this.subscription.add(this.sportsService.srcSelectionChanged$.subscribe(s => {
        setTimeout(() => {
          this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
          // this.srcSelection = {
          //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
          //   region: this.sportsService.sportRegionCompetitionSelection.region,
          //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
          // };
          this.setShowMobileTree();

        });
      }));
    }

  }

  test() {
    this.userActivityService.logout();
  }

  login(){
    // this.router.navigate(['/account/login']);
    // if (!this.loginParam.username || !this.loginParam.password) {
    //   this.showError = true;
    //   this.errorText = 'Username or password is required';
    //   return;
    // }
    // this.authenticateService.login(this.loginParam.username, this.loginParam.password).subscribe(isLogedIn => {
    //   if (isLogedIn) {
    //     this.router.navigate(['/account/cashiers']);
    //   }
    // });
  }

  account(){
    this.router.navigate(['/account']);
  }

  register(){
    this.router.navigate(['/account/register']);
  }

  resetPass(){
    this.router.navigate(['/account/reset-password']);
  }

  logOut(){
    this.tmUserService.logout();
  }

  setShowMobileTree() {
    if ((this.srcSelection && this.srcSelection.sport && (this.srcSelection.region || this.srcSelection.sport.specialOfferType))
      || this.pageType === PageType.Soon || this.pageType === PageType.MostPopular) {
      this.hideMobileTree = true;
    } else {
      this.hideMobileTree = false;
    }
  }


  ngOnInit() {
    super.ngOnInit();
    // this.setResultsDays();
    this.pageType = ViewConfigurations.useSoonViewWhenTimeFilterIsChanged && !this.sportsService.loadCompetitionOrEventFromQuery ? (this.queryParamService.pageType ? this.queryParamService.pageType : PageType.Soon) : PageType.Prematch;
    this.queryParamService.pageType = this.pageType;
  }

  protected pageTypeChanged() {

    this.pageType = this.queryParamService.pageType;

    if (this.pageType !== PageType.Results) {
      this.showResultsTimeFilter = false;
      this.resultTimeFilterValue = TimeFilter.None;
    }

    if (this.isMobileView) {
      this.setShowMobileTree();
    }
  }

  // openResultMenu() {
  //   this.showResultsTimeFilter = !this.showResultsTimeFilter;

  //   if (!this.showResultsTimeFilter) {
  //     return;
  //   }
  //   this.setResultsDays();
  // }

  // private setResultsDays() {
  //   this.resultsToday = new Date();
  //   this.resultsD1 = new Date(this.resultsToday.getTime() - (24 * 60 * 60 * 1000));
  //   this.resultsD2 = new Date(this.resultsToday.getTime() - (48 * 60 * 60 * 1000));
  //   this.resultsD3 = new Date(this.resultsToday.getTime() - (72 * 60 * 60 * 1000));
  //   this.resultsD4 = new Date(this.resultsToday.getTime() - (96 * 60 * 60 * 1000));
  //   this.resultsD5 = new Date(this.resultsToday.getTime() - (120 * 60 * 60 * 1000));
  //   this.resultsD6 = new Date(this.resultsToday.getTime() - (144 * 60 * 60 * 1000));
  // }

  public selectResultsTimeFilter(filterValue: TimeFilter) {
    if (this.pageType !== PageType.Results) {
      this.queryParamService.pageType = PageType.Results;
    }
    if (this.resultTimeFilterValue !== +filterValue) {
      this.resultTimeFilterValue = +filterValue;
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.cacheChangesService.removeAllEventsChangesSubscription(false);
    this.cacheChangesService.removeSportsSubscribtion(false);
    this.cacheChangesService.removeCompetitionsSubscribtion(false);
    this.cacheChangesService.unsubscribeForAllChangesPm();
  }
}
